export default __webpack_public_path__ + "static/media/eye.85cc85ac.svg";